import { createAction, props } from '@ngrx/store';

export const checkToken = createAction(
  '[GDPR Notice] Check Token',
  props<{ token: string }>()
);

// You can also define success and failure actions if needed
export const checkTokenSuccess = createAction(
  '[GDPR Notice] Check Token Success',
  props<{ data: any }>()
);

export const checkTokenFailure = createAction(
  '[GDPR Notice] Check Token Failure',
  props<{ error: any }>()
);

export const optOut = createAction(
  '[GDPR Notice] Opt Out',
  props<{ token: string }>()
);

export const optOutSuccess = createAction(
  '[GDPR Notice] Opt Out Success',
  props<{ data: any }>()
);

export const optOutFailure = createAction(
  '[GDPR Notice] Opt Out Failure',
  props<{ error: any }>()
);
